<template>
  <ContentWrapperControl class="mt-4">
    <div class="grid grid-cols-2 gap-4">
      <ServicesCardControl
        :icon="this.getEFTIcon()"
        :title="lang('lbl_0000297')"
        :description="lang('lbl_0000304')"
        href="/services/eft"
      />
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import ServicesCardControl from "@/components/controls/ServicesCardControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  emits: ["checkauth", "shownavbar", "nofooter"],
  components: {
    ContentWrapperControl,
    ServicesCardControl,
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000296"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
  },
  methods: {
    getEFTIcon() {
      const path = "icons/";
      const file_name = "papsi_eft.png";
      if (process.env.VUE_APP_CDN_URL) {
        return process.env.VUE_APP_CDN_URL + path + file_name;
      }
    },
  }
};
</script>
